/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.CertificationChirpService
 */
import * as References from './CertificationChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.CertificationChirpService#getCertificationMetadata
 */
export const GET_CERTIFICATION_METADATA_QUERY_FIELD_NAME = 'com_hubspot_learning_center_credentials_rpc_CertificationChirpService_getCertificationMetadata';
export const GET_CERTIFICATION_METADATA_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CERTIFICATION_METADATA_QUERY_FIELD_NAME,
  args: ['certificationId', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getCertificationMetadataRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});